/**
 * Images Tab Content Component
 * Renders the images tab content for a response pair
 */

import React from 'react';
import {
  spacing,
  typographyColors,
  typography,
  fontPrimary,
} from '@/design-system/utils';

export interface ImagesTabContentProps {
  isActive: boolean;
}

export const ImagesTabContent: React.FC<ImagesTabContentProps> = ({
  isActive,
}) => {
  return (
    <div
      style={{
        paddingTop: spacing[4],
        paddingBottom: spacing[4],
        textAlign: 'center',
        display: isActive ? 'block' : 'none', // Hide instead of unmounting
      }}
    >
      <p
        style={{
          fontFamily: fontPrimary,
          fontSize: typography.size.base,
          fontWeight: typography.weight.regular,
          color: typographyColors.text,
          lineHeight: typography.lineHeight.relaxed,
        }}
      >
        Image gallery coming soon...
      </p>
    </div>
  );
};
